export default __webpack_public_path__ + "static/media/1-Ibrahim-Hvordan definerer du din identitet.3892ad24.mp4";